/*
Copyright 2022-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Heading, Text } from "@vector-im/compound-web";

import { Header, HeaderLogo, LeftNav, RightNav } from "../Header";
import { UserMenuContainer } from "../UserMenuContainer";
import styles from "./UnauthenticatedView.module.css";
import commonStyles from "./common.module.css";
import { AnalyticsNotice } from "../analytics/AnalyticsNotice";
import { useOptInAnalytics } from "../settings/settings";
import { LinkButton } from "../button/LinkButton";
import { useUrlParams } from "../UrlParams";

export const UnauthenticatedView: FC = () => {
  const { header } = useUrlParams();
  const [optInAnalytics] = useOptInAnalytics();
  const { t } = useTranslation();

  return (
    <div className={commonStyles.container}>
      {header === "standard" && (
        <Header>
          <LeftNav>
            <HeaderLogo />
          </LeftNav>
          <RightNav hideMobile>
            <UserMenuContainer />
          </RightNav>
        </Header>
      )}
      <main className={commonStyles.main}>
        <HeaderLogo className={commonStyles.logo} />
        <Heading size="lg" weight="semibold" className={styles.heading}>
          {t("login_title")}
        </Heading>
        <Text size="md" className={styles.message}>
          Login to join scheduled meetings or rejoin your recent calls.
        </Text>
        {optInAnalytics === null && (
          <Text size="sm" className={styles.notice}>
            <AnalyticsNotice />
          </Text>
        )}
        <LinkButton to="/login" size="lg" data-testid="home_login">
          {t("unauthenticated_view_login_button")}
        </LinkButton>
      </main>
    </div>
  );
};
